import { TABLES_HAVING_PK_OTHER_THAN_ID } from "../constants/tablesHavingPkOtherThanId";

export const checkIfTablePkIsOtherThanId = (resource: string) =>
  Object.keys(TABLES_HAVING_PK_OTHER_THAN_ID).some((key) => resource === key);
